<template>
	<el-dialog
		title="欠费明细"
		:visible.sync="dialogVisible"
		width="70%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<!-- 表格 -->
		<BaseTable
			:selection="false"
			shadow="never"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="pageNum"
			:pageSize="pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template slot-scope="{ row }">
				<span :style="row.isSummary ? 'font-weight: bold; color: #333;' : ''">
					{{ row.resourceCode }}
				</span>
			</template>
		</BaseTable>
	</el-dialog>
</template>

<script>
	export default {
		name: 'WriteOffDetailsDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.fileList = [];
						this.form.voucherUrl = '';
					});
				}
			},
		},
		data() {
			return {
				total: 2,
				pageNum: 1,
				pageSize: 10,
				loading: false,
				columns: [
					{ prop: 'resourceCode', label: '资源编码' },
					{ prop: 'customerName', label: '客户名称', width: '120px' },
					{ prop: 'feeType', label: '费用类型', width: '100px' },
					{ prop: 'chargeItem', label: '收费项目', width: '160px' },
					{ prop: 'billPeriod', label: '应收账期', width: '120px' },
					{ prop: 'principalUncollected', label: '本金欠收', width: '120px' },
					{ prop: 'penaltyUncollected', label: '违约金欠收', width: '120px' },
					{ prop: 'totalUncollected', label: '欠收合计', width: '120px' },
					{ prop: 'principalReceived', label: '实收本金', width: '120px' },
					{ prop: 'penaltyReceived', label: '实收违约金', width: '120px' },
				],
				tableData: [
					{
						resourceCode: '01-0303',
						customerName: '厉千凡',
						feeType: '应收',
						chargeItem: '车位管理费',
						billPeriod: '2023-10',
						principalUncollected: 70.0,
						penaltyUncollected: 0.0,
						totalUncollected: 70.0,
						principalReceived: 70.0,
						penaltyReceived: 0.0,
					},
					{
						resourceCode: '01-0303',
						customerName: '厉千凡',
						feeType: '应收',
						chargeItem: '物业管理费',
						billPeriod: '2023-10',
						principalUncollected: 218.38,
						penaltyUncollected: 0.0,
						totalUncollected: 218.38,
						principalReceived: 148.38,
						penaltyReceived: 0.0,
					},

					// ✅ 合计行
					{
						resourceCode: '合计：',
						customerName: '',
						feeType: '',
						chargeItem: '',
						billPeriod: '',
						principalUncollected: 288.38,
						penaltyUncollected: 0.0,
						totalUncollected: 288.38,
						principalReceived: 218.38,
						penaltyReceived: 0.0,
						isSummary: true,
					},
				],
			};
		},
		created() {},
		methods: {
			pageChange(page) {
				this.pageNum = page;
			},
			sizeChange(size) {
				this.pageSize = size;
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
